import { formatDistanceToNowStrict } from 'date-fns';
import { useEffect, useState } from 'react';
import { PRIVACY_ROUTE, TERMS_ROUTE } from '../../constants/routes';
import { useModalState } from '../../hooks/useModalState';
import { Alert } from '../Alert';
import { Button } from '../catalyst-ui-kit/button';
import { Checkbox, CheckboxField } from '../catalyst-ui-kit/checkbox';
import { Link } from '../catalyst-ui-kit/link';
import { ResponsiveModal } from '../ResponsiveModal/ResponsiveModal';

export const TermsModal: React.FC<{
  address: string | undefined;
  termsAgreedAt: number | undefined;
  onAgreed: () => void;
  onSignOut: () => void;
}> = ({ address, termsAgreedAt, onAgreed, onSignOut }) => {
  const isOpen = useModalState((state) => state.termsModal === 'open');

  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [agreedToCookies, setAgreedToCookies] = useState(false);

  useEffect(() => {
    // Reset toggles when address changes
    setAgreedToTerms(false);
    setAgreedToCookies(false);
  }, [address]);

  return (
    <ResponsiveModal
      onClose={onSignOut}
      open={isOpen}
      title="Terms of Use and Privacy"
      panelClassName="sm:max-w-[406px]"
      childrenContainerClassName="flex flex-col space-y-4 text-sm font-medium"
    >
      <p className="mb-1">To continue, please review and agree to the following</p>
      {termsAgreedAt ? (
        <Alert>
          You confirmed{' '}
          {formatDistanceToNowStrict(termsAgreedAt, {
            addSuffix: true,
          })}{' '}
          that you have read, understood and accepted the{' '}
          <Link to={TERMS_ROUTE} className="text-contentBlue" target="_blank">
            Terms of Use
          </Link>{' '}
          and{' '}
          <Link to={PRIVACY_ROUTE} className="text-contentBlue" target="_blank">
            Privacy Policy
          </Link>
          .
        </Alert>
      ) : (
        <>
          <CheckboxField
            className="mr-3 cursor-pointer text-sm"
            onClick={() => setAgreedToTerms(!agreedToTerms)}
          >
            <Checkbox checked={agreedToTerms} onChange={(newValue) => setAgreedToTerms(newValue)} />
            <p className="w-full">
              I confirm that I have read, understood and accepted the{' '}
              <Link to={TERMS_ROUTE} className="text-contentBlue" target="_blank">
                Terms of Use
              </Link>{' '}
              and{' '}
              <Link to={PRIVACY_ROUTE} className="text-contentBlue" target="_blank">
                Privacy Policy
              </Link>
              .
            </p>
          </CheckboxField>
          <CheckboxField
            className="mr-3 cursor-pointer text-sm"
            onClick={() => setAgreedToCookies(!agreedToCookies)}
          >
            <Checkbox
              checked={agreedToCookies}
              onChange={(newValue) => setAgreedToCookies(newValue)}
            />
            <p className="w-full">
              This site uses cookies to enhance your browsing experience. By continuing to use this
              site, you consent to our cookie policy.
            </p>
          </CheckboxField>
        </>
      )}
      <div className="flex flex-col space-y-2">
        <Button
          color="blue"
          onClick={() => onAgreed()}
          disabled={!agreedToCookies || !agreedToTerms}
        >
          {termsAgreedAt ? 'Continue' : 'Agree & Continue'}
        </Button>
        {!termsAgreedAt ? (
          <Button outline onClick={() => onSignOut()}>
            Sign Out
          </Button>
        ) : null}
      </div>
    </ResponsiveModal>
  );
};
